import AuthStore from "./auth.store";
import DashboardStore from "./dashboard.store";
import EntityStore from "./entity.store";
import UserStore from "./user.store";
import GuaranteeStore from "./guarantee.store";
import DispensingStore from "./dispensing.store";
import ParticipantStore from "./participant.store";
import PhysicianStore from "./physician.store";
import ClaimsStore from "./claim.store";
import PharmaciesStore from "./pharmacy.store";
import DateRangeStore from "./daterange.store";
import GroupStore from "./group.store";
import PgxStore from "./pgx.store";
import RxTourismStore from "./rxtourism.store";
import PcmSavingsStore from "./pcmsaving.store";
import OpioidUsageStore from "./opioidusage.store";
import DawReviewStore from "./dawreview.store";
import LowValueDrugsStore from "./lowvaluedrugs.store";
import BudgetPlanningStore from "./budgetplanning.store";
import NdcPricingStore from "./ndcpricing.store";
import NoCopayStore from "./nocopay.store";
import EligibilityStore from "./eligibility.store";
import ExecutiveSummaryStore from "./executivesummary.store";
import PerformancePackageStore from "./performancepackage.store";
import BobSavingsStore from "./bobsavings.store";
import PharmacyRebateStore from "./pharmacyrebate.store";
import PharmacyActionStore from "./pharmacyaction.store";
import AdminStore from "./admin.store";
import LabelStore from "./label.store";
import ReportStore from "./report.store";
import AlternativeFundingStore from "./alternativefunding.store";
import SpecialtyCarveOutStore from "./specialtycarveout.store";
import RebateManagementStore from "./rebatemanagement.store";
import InternationalRxStore from "./internationalrx.store";
import CostPlusStore from './costplus.store'
import RebatesStore from "./rebates.store";
import SettingStore from "./setting.store";
import DashboardCommonsStore from "./dashboardcommons.store";
import MarketCheckStore from "./marketcheck.store";
import DrugSearchStore from "./drugsearch.store";
import ReportBookStore from "./report_book.store";
import BenzoUsageStore from "./benzousage.store";
import CfoSummaryStore from "./cfo_summary.store";
import MedicalSummaryStore from "./Medical/summary.store";
import MedicalClaimsStore from "./Medical/claims.store";
import MedicalProvidersStore from "./Medical/providers.store";
import MedicalPhysiciansStore from "./Medical/physicians.store";
import MedicalDiagnosisStore from "./Medical/diagnosis.store";
import MedicalProcedureStore from "./Medical/procedure.store";
import MedicalParticipantsStore from "./Medical/participant.store";
import MedicalMarketCheckStore from "./Medical/medicalmarketcheck.store";
import MedicalInsightsStore from "./Medical/insights.store";
import MedicalRecommendationStore from "./Medical/recommendation.store";
import MedicalMedicareLookupStore from "./Medical/medicarelookup.store";
import NdcLookUpStore from "./ndc_lookup.store";
import BrokerAdminStore from "./brokeradmin.store";
import BrokerIndexStore from "./broker_index.store";
import SavedContractStore from "./savedcontracts.store";
import SpecialtyPerformanceStore from "./specialtyperformance.store";
import AWPValidationStore from "./awpvalidation.store";
import ClinicalReviewStore from "./clinicalreview.store";
import TemplateStore from "./template.store";
import DefaultSettingStore from "./defaultsetting.store";
import MarketCheckProgramStore from "./marketcheckprogram.store";
import ChronicCareManagementStore from "./chroniccaremanagement.store";
import PharmacySavingsStore from "./pharmacySavings.store";
import RxValetPapStore from "./rxvaletpap.store";
import RxValetInternationalStore from "./rxvaletinternational.store";
import InternationalTeleHealthStore from "./internationaltelehealth.store";

class RootStore {
  constructor() {
    this.AuthStore = new AuthStore();
    this.DashboardStore = new DashboardStore();
    this.EntityStore = new EntityStore();
    this.UserStore = new UserStore();
    this.GuaranteeStore = new GuaranteeStore();
    this.DispensingStore = new DispensingStore();
    this.ParticipantStore = new ParticipantStore();
    this.PhysicianStore = new PhysicianStore();
    this.ClaimsStore = new ClaimsStore();
    this.PharmaciesStore = new PharmaciesStore();
    this.DateRangeStore = new DateRangeStore();
    this.GroupStore = new GroupStore();
    this.PgxStore = new PgxStore();
    this.RxTourismStore = new RxTourismStore();
    this.PcmSavingsStore = new PcmSavingsStore();
    this.OpioidUsageStore = new OpioidUsageStore();
    this.DawReviewStore = new DawReviewStore();
    this.LowValueDrugsStore = new LowValueDrugsStore();
    this.BudgetPlanningStore = new BudgetPlanningStore();
    this.NdcPricingStore = new NdcPricingStore();
    this.NoCopayStore = new NoCopayStore();
    this.EligibilityStore = new EligibilityStore();
    this.ExecutiveSummaryStore = new ExecutiveSummaryStore();
    this.PerformancePackageStore = new PerformancePackageStore();
    this.BobSavingsStore = new BobSavingsStore();
    this.PharmacyRebateStore = new PharmacyRebateStore();
    this.PharmacyActionStore = new PharmacyActionStore();
    this.AdminStore = new AdminStore();
    this.LabelStore = new LabelStore();
    this.ReportStore = new ReportStore();
    this.AlternativeFundingStore = new AlternativeFundingStore();
    this.SpecialtyCarveOutStore = new SpecialtyCarveOutStore();
    this.RebateManagementStore = new RebateManagementStore();
    this.InternationalRxStore = new InternationalRxStore();
    this.CostPlusStore = new CostPlusStore();
    this.RebatesStore = new RebatesStore();
    this.SettingStore = new SettingStore();
    this.DashboardCommonsStore = new DashboardCommonsStore();
    this.MarketCheckStore = new MarketCheckStore();
    this.DrugSearchStore = new DrugSearchStore();
    this.ReportBookStore = new ReportBookStore();
    this.BenzoUsageStore = new BenzoUsageStore();
    this.CfoSummaryStore = new CfoSummaryStore();
    this.MedicalSummaryStore = new MedicalSummaryStore();
    this.MedicalClaimsStore = new MedicalClaimsStore();
    this.MedicalProvidersStore = new MedicalProvidersStore();
    this.MedicalPhysiciansStore = new MedicalPhysiciansStore();
    this.MedicalDiagnosisStore = new MedicalDiagnosisStore();
    this.MedicalProcedureStore = new MedicalProcedureStore();
    this.MedicalParticipantsStore = new MedicalParticipantsStore();
    this.MedicalMarketCheckStore = new MedicalMarketCheckStore();
    this.NdcLookUpStore = new NdcLookUpStore();
    this.BrokerAdminStore = new BrokerAdminStore();
    this.BrokerIndexStore = new BrokerIndexStore();
    this.SavedContractStore = new SavedContractStore();
    this.MedicalInsightsStore = new MedicalInsightsStore();
    this.SpecialtyPerformanceStore = new SpecialtyPerformanceStore();
    this.AWPValidationStore = new AWPValidationStore();
    this.ClinicalReviewStore = new ClinicalReviewStore();
    this.TemplateStore = new TemplateStore();
    this.DefaultSettingStore = new DefaultSettingStore();
    this.MarketCheckProgramStore = new MarketCheckProgramStore();
    this.ChronicCareManagementStore = new ChronicCareManagementStore();
    this.PharmacySavingsStore = new PharmacySavingsStore();
    this.MedicalRecommendationStore = new MedicalRecommendationStore();
    this.MedicalMedicareLookupStore = new MedicalMedicareLookupStore();
    this.RxValetPapStore = new RxValetPapStore();
    this.RxValetInternationalStore = new RxValetInternationalStore();
    this.InternationalTeleHealthStore = new InternationalTeleHealthStore();
  }
}

export default RootStore;
